export default {
  props: { completed: { type: Boolean, default: false } },
  data() {
    return { completionBusy: null, completionError: '', completionActivated: false }
  },
  computed: {
    canManageCompletion() {
      return this.user && (this.user.is_superuser || this.user.user_type === 'ma')
    },
  },
  activated() {
    if (this.completionActivated) this.fetchPacking()
    this.completionActivated = true
  },
  methods: {
    changeCompletion(packageItem, kind) {
      if (this.completionBusy !== null || !this.canManageCompletion) return
      const action = this.completed ? 'بازگشت به لیست پکینگ ها' : 'انتقال به پکینگ های تکمیل شده'
      if (!window.confirm(`${action} برای پکینگ ${packageItem.title || packageItem.id} تأیید می‌شود؟`)) return
      this.completionBusy = packageItem.id
      this.completionError = ''
      this.request({
        url: this.endpoint(`entrance/${kind}EntrancePackage/${packageItem.id}/completion`),
        method: 'post', data: { is_completed: !this.completed },
        success: () => {
          this.completionBusy = null
          if (this.packages.length === 1 && this.currentPage > 1) this.currentPage--
          this.fetchPacking()
        },
        error: error => {
          this.completionBusy = null
          this.completionError = error.response && error.response.data && error.response.data.detail
            || 'تغییر وضعیت ثبت نشد؛ دوباره تلاش کنید.'
        },
      })
    },
  },
}
